import { useContext, useEffect, useState } from "react";
import { ExportRelatorioContext } from "../ExportRelatorioContext";
import { AutoCompleteInput, DataInput, DataInputMesAno, ModoSaidaInput, TextFieldInput } from "./Inputs";
import ContasContabeisInput from "./ContasContabeisInput";
import { buscarComboPorCodigo } from "../../../services/auth.service";
import { isFiltroContasContabeis } from "../../../utils/apuracaoFiltros.util";

const FiltrosDinamicos = () => {
  const { filtros, apuracao } = useContext(ExportRelatorioContext);
  const [comboOptions, setComboOptions] = useState({});

  const handleRenderListAutoComplete = async (codCombo) => {
    try {
      const response = await buscarComboPorCodigo(codCombo);
      const combosFormat = (response?.detalhes?.itensCombo ?? [])
        .filter((item) => typeof item === "string" && item.includes("/|/"))
        .map((item) => {
          const [id, detalhes] = item.split("/|/");
          return {
            id: id?.trim(),
            detalhes: detalhes?.trim() || "(sem descrição)",
          };
        });

      const uniqueCombos = combosFormat.filter(
        (combo, index, self) =>
          index === self.findIndex((t) => t.detalhes === combo.detalhes)
      );

      return uniqueCombos;
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const buscaCombos = async () => {
      for (const filtro of filtros) {
        if (filtro.tipoDado === "autocomplete") {
          const listaCombo = await handleRenderListAutoComplete(
            filtro.codCombo
          );
          setComboOptions({ ...comboOptions, [filtro.codCombo]: listaCombo });
        }
      }
    };

    filtros.length > 0 && buscaCombos();
  }, [filtros]);

  const handleRenderFiltro = (filtro) => {
    switch (true) {
      case isFiltroContasContabeis(filtro):
        return <ContasContabeisInput />;
      case filtro.variavel === "$F{p_notas_saida}" || filtro.nome === "Modo de saída":
        return <ModoSaidaInput filtro={filtro} />;
      case filtro.tipoDado === "data":
        // Se apuracao = true, usa componente MM/YYYY para TODOS os filtros de data
        if (apuracao) {
          return <DataInputMesAno filtro={filtro} />;
        }
        return <DataInput filtro={filtro} />;
      case filtro.tipoDado === "autocomplete":
        return (
          <AutoCompleteInput
            filtro={filtro}
            combos={comboOptions[filtro.codCombo]}
          />
        );
      default:
        return <TextFieldInput filtro={filtro} />;
    }
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '1rem' }}>
      {filtros?.map((item) => {
        return <div key={item.variavel}>{handleRenderFiltro(item)}</div>;
      })}
    </div>
  );
};

export default FiltrosDinamicos;
